module.exports = __webpack_public_path__ + "img/Group 1-1.0cfb02dd.png";